import { SET_SATSER, SetSatserAction, SetUniversiteterAction, SET_UNIVERSITETER } from './Types';
import { StamdataUtlandHelgradModel } from '../../Models/StamdataUtlandHelgradModel';
import LandOgUniversitetModel from '../../../Shared/Scripts/Models/LandOgUniversitetModel';

export function setSatser(satser: StamdataUtlandHelgradModel): SetSatserAction {
    return {
        type: SET_SATSER,
        payload: satser,
    };
}

export function setUniversiteter(universiteter: Array<LandOgUniversitetModel>): SetUniversiteterAction {
    return {
        type: SET_UNIVERSITETER,
        payload: universiteter
    }
}